import API from "./API"

export const fetchReportData = reportHash =>
  API.get(`report-data/${reportHash}/`)

export const fetchGrowerReportData = reportHash =>
  API.get(`grower-report-data/${reportHash}/`)

export const fetchTrialReportData = reportHash => API.get(`trial-report-data/${reportHash}/`)
